import React from "react";
import { Link } from "react-router-dom";
import ArrowPng from "../assets/images/ArrowLocation.png";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="container">
        <h1>page not found</h1>
        <p>sorry, the page you're looking for does not exist.</p>
        <Link to="/" className="cta-button">
          <span>go to home</span>
          <span>
            <img src={ArrowPng} alt="arrowpng"></img>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
